export default __webpack_public_path__ + "static/bara-ec8dd4482c7ccff932c32916b425a9d8.png";